import slr36 from "../../assets/images/product/slr36.png"
import slr18 from "../../assets/images/product/slr18.png"
import slr8 from "../../assets/images/product/slr8.png"
import offRoad from "../../assets/images/product/off_roader.png"
import truckAc from "../../assets/images/product/truck_ac.png"
import trans from "../../assets/images/product/transport-refregeration-system_01.png"
import indoor from "../../assets/images/product/Indoor Unit 2.png"
import indoor1 from "../../assets/images/product/Indoor Unit 3.png"
import window from "../../assets/images/product/Window AC.png"
import split from "../../assets/images/product/Split AC 1.png"
import tower from "../../assets/images/product/Tower AC ICF (1).jpg"
import ele from "../../assets/images/product/ElecHVAC.jpg"
import diesel from "../../assets/images/product/Diesel HVAC (1).jpg"
import eva from "../../assets/images/product/eva.png";
import heat from "../../assets/images/product/heatercore_01.png"
import cond2 from "../../assets/images/product/condensor_2.png"
import cond from "../../assets/images/product/condensor.png"
import com from "../../assets/images/product/compressor01.png"
import com2 from "../../assets/images/product/compressor_02.png"
import com3 from "../../assets/images/product/com.png"
import tubes from "../../assets/images/product/tubes-and-hoses.png"
import railAc from "../../assets/images/product/rail-ac.png"



const productsData = [
  {
    id: 15,
    itemName: "Window AC",
    img:window,
    category: "Residential AC",
    rating: 4,
    sellingPrice: 19390,
    USP:"Subros has a complete range of Residential Air Conditioners i.e. Window AC & Split AC system & supplying these products as OEM/ODM to all the leading brands in the Market.",
    SKU:"WIN01",
  },
  {
    id: 16,
    itemName: "Light Commercial AC",
    img:indoor1,
    category: "Commercial AC",
    rating: 4,
    sellingPrice: 18430,
    USP:"Subros caters to the demands of both Residential & Commercial Air-conditioner Market by providing a comprehensive product range of Light Commercial AC (1.5 TR ~ 4.0 TR ) & Ductable AC ranges ( 5.5 TR ~ 17.0 TR) to the customer.",
    SKU:"COMM01",
  },
  {
    id: 17,
    itemName: "Ductable AC",
    img:indoor,
    category: "Commercial AC",
    rating: 4,
    sellingPrice: 17550,
    USP:"Subros caters to the demands of both Residential & Commercial Air-conditioner Market by providing a comprehensive product range of Light Commercial AC (1.5 TR ~ 4.0 TR ) & Ductable AC ranges ( 5.5 TR ~ 17.0 TR) to the customer.",
    SKU:"COMM02",
  },
  {
    id: 19,
    itemName: "Truck Cabin AC System",
    img:truckAc,
    category: "Truck Cabin AC",
    rating: 5,
    sellingPrice: 22220,
    USP:"Featuring next generation technologies, Subros provides a complete range of Truck Cabin AC Systems",
    SKU:"TRS02",
  },
  {
    id: 20,
    itemName: "Off Roader AC",
    img:offRoad,
    category: "Off Roader AC",
    rating: 5,
    sellingPrice: 23540,
    USP:"Subros is into designing, manufacturing and supply of Off-Roader AC systems providing heating, ventilation and cooling solutions in case of construction and agricultural machinery such as Tractors, etc.",
    SKU:"ORA02",
  },
  {
    id: 1,
    itemName: "SLR 36",
    img:slr36,
    category: "Bus AC",
    rating: 4,
    sellingPrice: 15000,
    USP:"Introducing our cutting-edge Roof Unit, a compact powerhouse with a 36 KW cooling capacity. Measuring 3720 X 2000 X 243 mm, it delivers a refreshing air flow of 6600 m3/h. Powered by a reliable Bitzer/Valeo compressor (650 cc), it operates at an efficient 68A @ 24V. Elevate your climate control with this sleek, space-saving solution – where advanced cooling meets optimized design for unparalleled performance.",
    SKU:"SLR36",
  },
  {
    id: 2,
    itemName: "SLR 18",
    img:slr18,
    category: "Bus AC",
    rating: 5,
    sellingPrice: 14000,
    USP:"Introducing our cutting-edge Roof Unit, a compact powerhouse with a 36 KW cooling capacity. Measuring 3720 X 2000 X 243 mm, it delivers a refreshing air flow of 6600 m3/h. Powered by a reliable Bitzer/Valeo compressor (650 cc), it operates at an efficient 68A @ 24V. Elevate your climate control with this sleek, space-saving solution – where advanced cooling meets optimized design for unparalleled performance.",
    SKU:"SLR18",
  },
  {
    id: 3,
    itemName: "SLR 8",
    img:slr8,
    category: "Bus AC",
    rating: 3,
    sellingPrice: 16000,
    USP:"Introducing our cutting-edge Roof Unit, a compact powerhouse with a 36 KW cooling capacity. Measuring 3720 X 2000 X 243 mm, it delivers a refreshing air flow of 6600 m3/h. Powered by a reliable Bitzer/Valeo compressor (650 cc), it operates at an efficient 68A @ 24V. Elevate your climate control with this sleek, space-saving solution – where advanced cooling meets optimized design for unparalleled performance.",
    SKU:"SLR08",
  },
];

const newProductData = [
  {
    id: 1,
    itemName: "SLR 36",
    img:slr36,
    category: "Bus AC",
    rating: 4,
    sellingPrice: 15000,
    USP:"Introducing our cutting-edge Roof Unit, a compact powerhouse with a 36 KW cooling capacity. Measuring 3720 X 2000 X 243 mm, it delivers a refreshing air flow of 6600 m3/h. Powered by a reliable Bitzer/Valeo compressor (650 cc), it operates at an efficient 68A @ 24V. Elevate your climate control with this sleek, space-saving solution – where advanced cooling meets optimized design for unparalleled performance.",
    SKU:"SLR36",
  },
  {
    id: 2,
    itemName: "SLR 18",
    img:slr18,
    category: "Bus AC",
    rating: 5,
    sellingPrice: 14000,
    USP:"Introducing our cutting-edge Roof Unit, a compact powerhouse with a 36 KW cooling capacity. Measuring 3720 X 2000 X 243 mm, it delivers a refreshing air flow of 6600 m3/h. Powered by a reliable Bitzer/Valeo compressor (650 cc), it operates at an efficient 68A @ 24V. Elevate your climate control with this sleek, space-saving solution – where advanced cooling meets optimized design for unparalleled performance.",
    SKU:"SLR18",
  },
  {
    id: 3,
    itemName: "SLR 8",
    img:slr8,
    category: "Bus AC",
    rating: 3,
    sellingPrice: 16000,
    USP:"Introducing our cutting-edge Roof Unit, a compact powerhouse with a 36 KW cooling capacity. Measuring 3720 X 2000 X 243 mm, it delivers a refreshing air flow of 6600 m3/h. Powered by a reliable Bitzer/Valeo compressor (650 cc), it operates at an efficient 68A @ 24V. Elevate your climate control with this sleek, space-saving solution – where advanced cooling meets optimized design for unparalleled performance.",
    SKU:"SLR08",
  },
  {
    id: 4,
    itemName: "10SA13",
    img:com3,
    category: "Compressors",
    rating: 3,
    sellingPrice: 25000,
    USP:"The 10SA13 is a compact FD Swash Plate compressor with 10 cylinders and a 125cc displacement, ideal for diverse applications requiring efficiency and reliability in compressed air or fluid handling.",
    SKU:"10SA13",
  },
  {
    id: 5,
    itemName: "10S13",
    img:com2,
    category: "Compressors",
    rating: 5,
    sellingPrice: 42800,
    USP:"The 10S13 is an FD Swash Plate compressor featuring 10 cylinders with a displacement of 138cc. This compressor is designed for efficient and reliable performance, making it well-suited for a variety of applications requiring compressed air or fluid handling.",
    SKU:"10S13",
  },
  {
    id: 6,
    itemName: "10S11",
    img:com,
    category: "Compressors",
    rating: 4,
    sellingPrice: 30020,
    USP:"The 10S11 is an FD Swash Plate compressor with 10 cylinders and a displacement of 117cc. This compact and reliable compressor is designed for versatility, making it suitable for a range of applications that require efficient compressed air or fluid handling.",
    SKU:"10S11",
  },
  {
    id: 7,
    itemName: "Multiflow",
    img:cond,
    category: "Condensers",
    rating: 5,
    sellingPrice: 11780,
    USP:"The new range of Multi-Flow condensers are a new revolution in heat exchangers, which are super efficient, small in size and light in weight.",
    SKU:"MUL01",
  },
  {
    id: 8,
    itemName: "Multiflow with IRD",
    img:cond2,
    category: "Condensers",
    rating: 4,
    sellingPrice: 11560,
    USP:"The new range of Multi-Flow with IRD condensers are a new revolution in heat exchangers, which are super efficient, small in size and light in weight.",
    SKU:"MUL02",
  },
  {
    id: 9,
    itemName: "Heaters",
    img:heat,
    category: "HVAC",
    rating: 5,
    sellingPrice: 11310,
    USP:"Aluminium Heater light weight, smaller in size, high heat transfer unit suitable for all vehicles.",
    SKU:"HEAT1",
  },
  {
    id: 10,
    itemName: "Evaporators",
    img:eva,
    category: "HVAC",
    rating: 5,
    sellingPrice: 12310,
    USP:"Aluminium Evaporators light weight, smaller in size, high heat transfer unit suitable for all vehicles.",
    SKU:"EVAP01",
  },
  {
    id: 11,
    itemName: "Diesel Hvac",
    img:diesel,
    category: "Rail AC",
    rating: 4,
    sellingPrice: 15390,
    USP:"Subros provides tailored system solutions for driver cabin AC of railway engines featuring compactness, flexibility and easiness to install, irrespective of whether they are diesel or electricity driven engine. ",
    SKU:"DIES01",
  },
  {
    id: 12,
    itemName: "Ele Hvac",
    img:ele,
    category: "Rail AC",
    rating: 4,
    sellingPrice: 16280,
    USP:"Subros provides tailored system solutions for driver cabin AC of railway engines featuring compactness, flexibility and easiness to install, irrespective of whether they are diesel or electricity driven engine. ",
    SKU:"ELE01",
  },
  {
    id: 13,
    itemName: "Tower Ac Icf",
    img:tower,
    category: "Rail AC",
    rating: 2,
    sellingPrice: 19290,
    USP:"Subros provides tailored system solutions for driver cabin AC of railway engines featuring compactness, flexibility and easiness to install, irrespective of whether they are diesel or electricity driven engine. ",
    SKU:"TOW01",
  },
  {
    id: 14,
    itemName: "Split AC",
    img:split,
    category: "Residential AC",
    rating: 2,
    sellingPrice: 16590,
    USP:"Subros has a complete range of Residential Air Conditioners i.e. Window AC & Split AC system & supplying these products as OEM/ODM to all the leading brands in the Market.",
    SKU:"SPL01",
  },
  {
    id: 15,
    itemName: "Window AC",
    img:window,
    category: "Residential AC",
    rating: 4,
    sellingPrice: 19390,
    USP:"Subros has a complete range of Residential Air Conditioners i.e. Window AC & Split AC system & supplying these products as OEM/ODM to all the leading brands in the Market.",
    SKU:"WIN01",
  },
  {
    id: 16,
    itemName: "Light Commercial AC",
    img:indoor1,
    category: "Commercial AC",
    rating: 4,
    sellingPrice: 18430,
    USP:"Subros caters to the demands of both Residential & Commercial Air-conditioner Market by providing a comprehensive product range of Light Commercial AC (1.5 TR ~ 4.0 TR ) & Ductable AC ranges ( 5.5 TR ~ 17.0 TR) to the customer.",
    SKU:"COMM01",
  },
  {
    id: 17,
    itemName: "Ductable AC",
    img:indoor,
    category: "Commercial AC",
    rating: 4,
    sellingPrice: 17550,
    USP:"Subros caters to the demands of both Residential & Commercial Air-conditioner Market by providing a comprehensive product range of Light Commercial AC (1.5 TR ~ 4.0 TR ) & Ductable AC ranges ( 5.5 TR ~ 17.0 TR) to the customer.",
    SKU:"COMM02",
  },
  {
    id: 18,
    itemName: "Transport Refrigeration System",
    img:trans,
    category: "Transport Refrigeration System",
    rating: 5,
    sellingPrice: 16520,
    USP:"Subros provides a complete range of transport refrigeration solutions suitable for storage volume upto 50 cu.m for chilling & freezing applications.",
    SKU:"TRS02",
  },
  {
    id: 19,
    itemName: "Truck Cabin AC System",
    img:truckAc,
    category: "Truck Cabin AC System",
    rating: 5,
    sellingPrice: 22220,
    USP:"Featuring next generation technologies, Subros provides a complete range of Truck Cabin AC Systems",
    SKU:"TRS02",
  },
  {
    id: 20,
    itemName: "Off Roader AC",
    img:offRoad,
    category: "Off Roader AC",
    rating: 5,
    sellingPrice: 23540,
    USP:"Subros is into designing, manufacturing and supply of Off-Roader AC systems providing heating, ventilation and cooling solutions in case of construction and agricultural machinery such as Tractors, etc.",
    SKU:"ORA02",
  },
]

const productsOfferData = [
  {
    id: 1,
    itemName: "SLR 36",
    img:slr36,
    category: "Bus AC",
    rating: 4,
    sellingPrice: 15000,
    USP:"Introducing our cutting-edge Roof Unit, a compact powerhouse with a 36 KW cooling capacity. Measuring 3720 X 2000 X 243 mm, it delivers a refreshing air flow of 6600 m3/h. Powered by a reliable Bitzer/Valeo compressor (650 cc), it operates at an efficient 68A @ 24V. Elevate your climate control with this sleek, space-saving solution – where advanced cooling meets optimized design for unparalleled performance.",
    SKU:"SLR36",
  },
  {
    id: 2,
    itemName: "SLR 18",
    img:slr18,
    category: "Bus AC",
    rating: 5,
    sellingPrice: 14000,
    USP:"Introducing our cutting-edge Roof Unit, a compact powerhouse with a 36 KW cooling capacity. Measuring 3720 X 2000 X 243 mm, it delivers a refreshing air flow of 6600 m3/h. Powered by a reliable Bitzer/Valeo compressor (650 cc), it operates at an efficient 68A @ 24V. Elevate your climate control with this sleek, space-saving solution – where advanced cooling meets optimized design for unparalleled performance.",
    SKU:"SLR18",
  },
  {
    id: 3,
    itemName: "SLR 8",
    img:slr8,
    category: "Bus AC",
    rating: 3,
    sellingPrice: 16000,
    USP:"Introducing our cutting-edge Roof Unit, a compact powerhouse with a 36 KW cooling capacity. Measuring 3720 X 2000 X 243 mm, it delivers a refreshing air flow of 6600 m3/h. Powered by a reliable Bitzer/Valeo compressor (650 cc), it operates at an efficient 68A @ 24V. Elevate your climate control with this sleek, space-saving solution – where advanced cooling meets optimized design for unparalleled performance.",
    SKU:"SLR08",
  },
  {
    id: 4,
    itemName: "10SA13",
    img:com3,
    category: "Compressors",
    rating: 3,
    sellingPrice: 25000,
    USP:"The 10SA13 is a compact FD Swash Plate compressor with 10 cylinders and a 125cc displacement, ideal for diverse applications requiring efficiency and reliability in compressed air or fluid handling.",
    SKU:"10SA13",
  },
  {
    id: 5,
    itemName: "10S13",
    img:com2,
    category: "Compressors",
    rating: 5,
    sellingPrice: 42800,
    USP:"The 10S13 is an FD Swash Plate compressor featuring 10 cylinders with a displacement of 138cc. This compressor is designed for efficient and reliable performance, making it well-suited for a variety of applications requiring compressed air or fluid handling.",
    SKU:"10S13",
  },
  {
    id: 6,
    itemName: "10S11",
    img:com,
    category: "Compressors",
    rating: 4,
    sellingPrice: 30020,
    USP:"The 10S11 is an FD Swash Plate compressor with 10 cylinders and a displacement of 117cc. This compact and reliable compressor is designed for versatility, making it suitable for a range of applications that require efficient compressed air or fluid handling.",
    SKU:"10S11",
  },
  {
    id: 7,
    itemName: "Multiflow",
    img:cond,
    category: "Condensers",
    rating: 5,
    sellingPrice: 11780,
    USP:"The new range of Multi-Flow condensers are a new revolution in heat exchangers, which are super efficient, small in size and light in weight.",
    SKU:"MUL01",
  },
  {
    id: 8,
    itemName: "Multiflow with IRD",
    img:cond2,
    category: "Condensers",
    rating: 4,
    sellingPrice: 11560,
    USP:"The new range of Multi-Flow with IRD condensers are a new revolution in heat exchangers, which are super efficient, small in size and light in weight.",
    SKU:"MUL02",
  },
];


const deportReportData = [
  {
    id: 1,
    ItemName: "AgroStar Fertilizer",
    SKU: "AGRO123",
    QuantityIn: 200,
    QuantityOut: 50,
    QuantityOrdered: 150,
    CommitedStock: 80,
    AvailableForSell: 120,
    StockOnHand: 170,
    WareHouseName:"Krishi"
  },
  {
    id: 2,
    ItemName: "Organic Pesticide",
    SKU: "ORGANIC456",
    QuantityIn: 300,
    QuantityOrdered: 200,
    QuantityOut: 100,
    CommitedStock: 50,
    AvailableForSell: 250,
    StockOnHand: 200,
    WareHouseName: "Krishi",
  },
  {
    id: 3,
    ItemName: "Hybrid Seeds Pack",
    SKU: "SEED789",
    QuantityIn: 500,
    QuantityOrdered: 350,
    QuantityOut: 150,
    CommitedStock: 120,
    AvailableForSell: 380,
    StockOnHand: 350,
    WareHouseName: "SeedHub",
  },
  {
    id: 4,
    ItemName: "Garden Tools Set",
    SKU: "TOOL567",
    QuantityIn: 100,
    QuantityOrdered: 70,
    QuantityOut: 30,
    CommitedStock: 20,
    AvailableForSell: 50,
    StockOnHand: 60,
    WareHouseName: "GardenCare",
  },
  {
    id: 5,
    ItemName: "Garden Tools Set",
    SKU: "TOOL567",
    QuantityIn: 100,
    QuantityOrdered: 70,
    QuantityOut: 30,
    CommitedStock: 20,
    AvailableForSell: 50,
    StockOnHand: 60,
    WareHouseName: "GardenCare"
  },
  {
    id: 6,
    ItemName: "Outdoor Furniture Set",
    SKU: "FURN123",
    QuantityIn: 50,
    QuantityOrdered: 20,
    QuantityOut: 10,
    CommitedStock: 5,
    AvailableForSell: 10,
    StockOnHand: 40,
    WareHouseName: "OutdoorLiving"
  },
  {
    id: 7,
    ItemName: "Plant Seeds Assortment",
    SKU: "SEED456",
    QuantityIn: 200,
    QuantityOrdered: 150,
    QuantityOut: 50,
    CommitedStock: 25,
    AvailableForSell: 125,
    StockOnHand: 75,
    WareHouseName: "SeedNursery"
  },
  {
    id: 8,
    ItemName: "Pest Control Kit",
    SKU: "PEST789",
    QuantityIn: 80,
    QuantityOrdered: 60,
    QuantityOut: 20,
    CommitedStock: 10,
    AvailableForSell: 50,
    StockOnHand: 30,
    WareHouseName: "EcoGuard"
  },
  {
    id: 9,
    ItemName: "Greenhouse Supplies Bundle",
    SKU: "GH456",
    QuantityIn: 120,
    QuantityOrdered: 90,
    QuantityOut: 30,
    CommitedStock: 15,
    AvailableForSell: 75,
    StockOnHand: 45,
    WareHouseName: "GreenThrive"
  },
  {
    id: 10,
    ItemName: "Lawn Maintenance Kit",
    SKU: "LAWN789",
    QuantityIn: 70,
    QuantityOrdered: 50,
    QuantityOut: 15,
    CommitedStock: 10,
    AvailableForSell: 40,
    StockOnHand: 25,
    WareHouseName: "LawnCareDepot"
  },
];

const deportData = [
  {
    id: 1,
    DepotName: "Central Depot",
    Address: "123 Main Street, Gandhi Nagar",
    City: "Bangalore",
    State: "Karnataka",
    Pincode: "560001",
    DepotInchargeMobilenumber: 9876543210,
    DepotInchargeEmailId: "ravi.sharma@example.in",
    DepotInchargeName: "Ravi Sharma"
  },
  {
    id: 2,
    DepotName: "Northern Depot",
    Address: "456 Elm Avenue, Civil Lines",
    City: "Delhi",
    State: "Delhi",
    Pincode: "110001",
    DepotInchargeMobilenumber: 8765432109,
    DepotInchargeEmailId: "priya.verma@example.in",
    DepotInchargeName: "Priya Verma"
  },
  {
    id: 3,
    DepotName: "Southern Warehouse",
    Address: "789 Oak Lane, Kotturpuram",
    City: "Chennai",
    State: "Tamil Nadu",
    Pincode: "600085",
    DepotInchargeMobilenumber: 7654321098,
    DepotInchargeEmailId: "suresh.kumar@example.in",
    DepotInchargeName: "Suresh Kumar"
  },
  {
    id: 4,
    DepotName: "Eastern Distribution Center",
    Address: "321 Pine Road, Salt Lake City",
    City: "Kolkata",
    State: "West Bengal",
    Pincode: "700064",
    DepotInchargeMobilenumber: 6543210987,
    DepotInchargeEmailId: "amit.das@example.in",
    DepotInchargeName: "Amit Das"
  },
  {
    id: 5,
    DepotName: "Western Depot",
    Address: "987 Maple Street, Andheri West",
    City: "Mumbai",
    State: "Maharashtra",
    Pincode: "400053",
    DepotInchargeMobilenumber: 5432109876,
    DepotInchargeEmailId: "sunita.patel@example.in",
    DepotInchargeName: "Sunita Patel"
  }
];

const deportDataForSalesUser = [
  {
    id: 2,
    DepotName: "Western Depot",
    Address: "456 Elm Avenue, Civil Lines",
    City: "Mumbai",
    State: "Maharashtra",
    Pincode: "710001",
    DepotInchargeMobilenumber: 8765432109,
    DepotInchargeEmailId: "priya.verma@example.in",
    DepotInchargeName: "Priya Verma"
  }

];

const exclusiveData = [
  {
    id: 17,
    itemName: "Ductable AC",
    img:indoor,
    category: "Commercial AC",
    rating: 4,
    sellingPrice: 17550,
    USP:"Subros caters to the demands of both Residential & Commercial Air-conditioner Market by providing a comprehensive product range of Light Commercial AC (1.5 TR ~ 4.0 TR ) & Ductable AC ranges ( 5.5 TR ~ 17.0 TR) to the customer.",
    SKU:"COMM02",
  },
  {
    id: 13,
    itemName: "Tower Ac Icf",
    img:tower,
    category: "Rail AC",
    rating: 2,
    sellingPrice: 19290,
    USP:"Subros provides tailored system solutions for driver cabin AC of railway engines featuring compactness, flexibility and easiness to install, irrespective of whether they are diesel or electricity driven engine. ",
    SKU:"TOW01",
  },
  {
    id: 14,
    itemName: "Split AC",
    img:split,
    category: "Residential AC",
    rating: 2,
    sellingPrice: 16590,
    USP:"Subros has a complete range of Residential Air Conditioners i.e. Window AC & Split AC system & supplying these products as OEM/ODM to all the leading brands in the Market.",
    SKU:"SPL01",
  },
  {
    id: 20,
    itemName: "Off Roader AC",
    img:offRoad,
    category: "Off Roader AC",
    rating: 5,
    sellingPrice: 23540,
    USP:"Subros is into designing, manufacturing and supply of Off-Roader AC systems providing heating, ventilation and cooling solutions in case of construction and agricultural machinery such as Tractors, etc.",
    SKU:"ORA02",
  }
]


const recentProducts = [
  {
    id: 1,
    img: "img7",
    name: "Wireless Headphone",
    link: "",
    rating: 4,
    oldPrice: 240,
    newPrice: 225,
  },
  {
    id: 2,
    img: "img4",
    name: "Smiley Plain T-shirt",
    link: "",
    rating: 4,
    oldPrice: 150,
    newPrice: 145,
  },
  {
    id: 3,
    img: "img6",
    name: "Sky blue color T-shirt",
    link: "",
    rating: 4,
    oldPrice: 138,
    newPrice: 135,
  },
];

const comments = [
  {
    id: 1,
    img: "avatar2",
    name: "Brian",
    description:
      "If several languages coalesce, the grammar of the resulting language.",
    date: "5 hrs ago",
  },
  {
    id: 2,
    img: "avatar4",
    name: "Denver",
    description:
      "To an English person, it will seem like simplified English, as a skeptical Cambridge",
    date: "07 Oct, 2019",
    childComment: [
      {
        id: 1,
        img: "avatar5",
        name: "Henry",
        description:
          "Their separate existence is a myth. For science, music, sport, etc.",
        date: "08 Oct, 2019",
      },
    ],
  },
  {
    id: 3,
    img: "Null",
    name: "Neal",
    description:
      "Everyone realizes why a new common language would be desirable.",
    date: "05 Oct, 2019",
  },
];

const discountData = [
  { label: "Less than 10%", value: 0 },
  { label: "10% or more", value: 10 },
  { label: "20% or more", value: 20 },
  { label: "30% or more", value: 30 },
  { label: "40% or more", value: 40 },
  { label: "50% or more", value: 50 },
];

const orders = [
  {
    id: 2,
    orderId: "#SK2540",
    billingName: "Ajit Kumar Khatua",
    orderdate: "07 Jan, 2023",
    total: "Rs 460000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Dispatch",
  },
  {
    id: 3,
    orderId: "#SK2541",
    billingName: "Ajay Jamage",
    orderdate: "07 Feb, 2023",
    total: "Rs 380000",
    badgeclass: "danger",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 4,
    orderId: "#SK2542",
    billingName: "Ketan Pradhan",
    orderdate: "06 Mar, 2023",
    total: "Rs 384000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-paypal",
    paymentMethod: "Delivered",
  },
  {
    id: 5,
    orderId: "#SK2543",
    billingName: "Alok Rout",
    orderdate: "05 Aug, 2023",
    total: "Rs 412000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Dispatch",
  },
  {
    id: 6,
    orderId: "#SK2544",
    billingName: "Ayushi Talekar",
    orderdate: "04 Apr, 2023",
    total: "Rs 404000",
    badgeclass: "warning",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 7,
    orderId: "#SK2545",
    billingName: "Gunjan Shukla",
    orderdate: "04 May , 2023",
    total: "Rs 392000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-paypal",
    paymentMethod: "Delivered",
  },
  {
    id: 8,
    orderId: "#SK2546",
    billingName: "Abhihek Jaiswal",
    orderdate: "03 Jun, 2023",
    total: "Rs 374000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fas fa-money-bill-alt",
    paymentMethod: "Delivered",
  },
  {
    id: 9,
    orderId: "#SK2544",
    billingName: "Ayushi Talekar",
    orderdate: "04 Apr, 2023",
    total: "Rs 764000",
    badgeclass: "warning",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 10,
    orderId: "#SK2540",
    billingName: "Ajit Kumar Khatua",
    orderdate: "07 Jan, 2023",
    total: "Rs 400000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Delivered",
  },
  {
    id: 11,
    orderId: "#SK2541",
    billingName: "Ajay Jamage",
    orderdate: "07 Feb, 2023",
    total: "Rs 380000",
    badgeclass: "danger",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 12,
    orderId: "#SK2546",
    billingName: "Abhihek Jaiswal",
    orderdate: "03 Jun, 2023",
    total: "Rs 374000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fas fa-money-bill-alt",
    paymentMethod: "Dispatch",
  },
  {
    id: 13,
    orderId: "#SK2541",
    billingName: "Ajay Jamage",
    orderdate: "07 Feb, 2023",
    total: "Rs 380000",
    badgeclass: "danger",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 14,
    orderId: "#SK2543",
    billingName: "Alok Rout",
    orderdate: "05 Aug, 2023",
    total: "Rs 412000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Dispatch",
  },
  {
    id: 15,
    orderId: "#SK2541",
    billingName: "Ajay Jamage",
    orderdate: "07 Feb, 2023",
    total: "Rs 380000",
    badgeclass: "danger",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 16,
    orderId: "#SK2546",
    billingName: "Abhihek Jaiswal",
    orderdate: "03 Jun, 2023",
    total: "Rs 374000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fas fa-money-bill-alt",
    paymentMethod: "Delivered",
  },
  {
    id: 17,
    orderId: "#SK2541",
    billingName: "Ajay Jamage",
    orderdate: "07 Feb, 2023",
    total: "Rs 380000",
    badgeclass: "danger",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Dispatch",
  },
  {
    id: 18,
    orderId: "#SK2543",
    billingName: "Alok Rout",
    orderdate: "05 Aug, 2023",
    total: "Rs 412000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Delivered",
  },
  {
    id: 19,
    orderId: "#SK2544",
    billingName: "Lokanath Debata",
    orderdate: "04 May, 2023",
    total: "Rs 404000",
    badgeclass: "warning",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 20,
    orderId: "#SK2545",
    billingName: "Akash Barik",
    orderdate: "04 Jun, 2023",
    total: "Rs 39200",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-paypal",
    paymentMethod: "Delivered",
  },
  {
    id: 21,
    orderId: "#SK2542",
    billingName: "Satyaprakash Barik",
    orderdate: "06 Jul, 2023",
    total: "Rs 38400",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-paypal",
    paymentMethod: "Delivered",
  },
  {
    id: 22,
    orderId: "#SK2544",
    billingName: "Ayushi Talekar",
    orderdate: "04 Apr, 2023",
    total: "Rs 40400",
    badgeclass: "warning",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 23,
    orderId: "#SK2540",
    billingName: "Ajit Kumar Khatua",
    orderdate: "07 Jan, 2023",
    total: "Rs 400000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Dispatch",
  },
  {
    id: 24,
    orderId: "#SK2540",
    billingName: "Ram Sharma",
    orderdate: "08 Aug, 2023",
    total: "Rs 400000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Delivered",
  },
  {
    id: 25,
    orderId: "#SK2546",
    billingName: "Abhihek Jaiswal",
    orderdate: "03 Jun, 2023",
    total: "Rs 3740000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fas fa-money-bill-alt",
    paymentMethod: "Dispatch",
  },
  {
    id: 26,
    orderId: "#SK2542",
    billingName: "Satyaprakash Barik",
    orderdate: "06 Jul, 2023",
    total: "Rs 384000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-paypal",
    paymentMethod: "Delivered",
  },
  {
    id: 27,
    orderId: "#SK2543",
    billingName: "Alok Rout",
    orderdate: "05 Aug, 2023",
    total: "Rs 412000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Dispatch",
  },
];

const returnOrders=[
  {
    id: 3,
    orderId: "#SK2541",
    billingName: "Ajay Jamage",
    orderdate: "07 Feb, 2023",
    total: "Rs 394880",
    badgeclass: "danger",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 9,
    orderId: "#SK2544",
    billingName: "Ayushi Talekar",
    orderdate: "04 Apr, 2023",
    total: "Rs 440000",
    badgeclass: "warning",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 11,
    orderId: "#SK2541",
    billingName: "Ajay Jamage",
    orderdate: "07 Feb, 2023",
    total: "Rs 38560",
    badgeclass: "danger",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 13,
    orderId: "#SK2541",
    billingName: "Ajay Jamage",
    orderdate: "07 Feb, 2023",
    total: "Rs 56000",
    badgeclass: "danger",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 15,
    orderId: "#SK2541",
    billingName: "Ajay Jamage",
    orderdate: "07 Feb, 2023",
    total: "Rs 89000",
    badgeclass: "danger",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 19,
    orderId: "#SK2544",
    billingName: "Lokanath Debata",
    orderdate: "04 May, 2023",
    total: "Rs 78000",
    badgeclass: "warning",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },
  {
    id: 22,
    orderId: "#SK2544",
    billingName: "Ayushi Talekar",
    orderdate: "04 Apr, 2023",
    total: "Rs 67540",
    badgeclass: "warning",
    paymentStatus: "Refund",
    methodIcon: "fa-cc-visa",
    paymentMethod: "Returned",
  },

]


const canceledOrders = [
  {
    id: 3,
    orderId: "#SK2541",
    billingName: "Sumit Kosta",
    orderdate: "07 Feb, 2023",
    total: "Rs 394880",
    badgeclass: "danger",
    status: "Cancelled",
    reason: "Order cancelled due to late expected delivery date",
  },
  {
    id: 9,
    orderId: "#SK2544",
    billingName: "Ayushi Talekar",
    orderdate: "04 Apr, 2023",
    total: "Rs 440000",
    badgeclass: "warning",
    status: "Cancelled",
    reason: "Found a better deal elsewhere",
  },
  {
    id: 11,
    orderId: "#SK2541",
    billingName: "Praphull Kumar",
    orderdate: "07 Feb, 2023",
    total: "Rs 38560",
    badgeclass: "danger",
    status: "Cancelled",
    reason: "Product didn't meet expectations",
  },
  {
    id: 13,
    orderId: "#SK2541",
    billingName: "Ajit Kumar",
    orderdate: "07 Feb, 2023",
    total: "Rs 56000",
    badgeclass: "danger",
    status: "Cancelled",
    reason: "Changed delivery address",
  },
  {
    id: 15,
    orderId: "#SK2541",
    billingName: "Ajay Jamage",
    orderdate: "07 Feb, 2023",
    total: "Rs 89000",
    badgeclass: "danger",
    status: "Cancelled",
    reason: "Received wrong product",
  },
  {
    id: 19,
    orderId: "#SK2544",
    billingName: "Lokanath Debata",
    orderdate: "04 May, 2023",
    total: "Rs 78000",
    badgeclass: "warning",
    status: "Cancelled",
    reason: "Product damaged upon delivery",
  },
];


const deliveredOrders=[
  {
    id: 4,
    orderId: "#SK2542",
    billingName: "Ketan Pradhan",
    orderdate: "06 Mar, 2023",
    total: "Rs 38400",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-paypal",
    paymentMethod: "Delivered",
  },
  {
    id: 7,
    orderId: "#SK2545",
    billingName: "Gunjan Shukla",
    orderdate: "04 May , 2023",
    total: "Rs 39200",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-paypal",
    paymentMethod: "Delivered",
  },
  {
    id: 8,
    orderId: "#SK2546",
    billingName: "Abhihek Jaiswal",
    orderdate: "03 Jun, 2023",
    total: "RS 76574",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fas fa-money-bill-alt",
    paymentMethod: "Delivered",
  },
  {
    id: 10,
    orderId: "#SK2540",
    billingName: "Ajit Kumar Khatua",
    orderdate: "07 Jan, 2023",
    total: "Rs 56908",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Delivered",
  },
  {
    id: 16,
    orderId: "#SK2546",
    billingName: "Abhihek Jaiswal",
    orderdate: "03 Jun, 2023",
    total: "Rs 89745",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fas fa-money-bill-alt",
    paymentMethod: "Delivered",
  },
  {
    id: 18,
    orderId: "#SK2543",
    billingName: "Alok Rout",
    orderdate: "05 Aug, 2023",
    total: "Rs 69012",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Delivered",
  },
  {
    id: 20,
    orderId: "#SK2545",
    billingName: "Akash Barik",
    orderdate: "04 Jun, 2023",
    total: "Rs 89740",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-paypal",
    paymentMethod: "Delivered",
  },
  {
    id: 21,
    orderId: "#SK2542",
    billingName: "Satyaprakash Barik",
    orderdate: "06 Jul, 2023",
    total: "Rs 98674",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-paypal",
    paymentMethod: "Delivered",
  },
  {
    id: 24,
    orderId: "#SK2540",
    billingName: "Ram Sharma",
    orderdate: "08 Aug, 2023",
    total: "Rs 92000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Delivered",
  },
  {
    id: 26,
    orderId: "#SK2542",
    billingName: "Satyaprakash Barik",
    orderdate: "06 Jul, 2023",
    total: "Rs 156000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-paypal",
    paymentMethod: "Delivered",
  },
]


const pendingOrders = [
  {
    id: 2,
    orderId: "#SK2540",
    billingName: "Ajit Kumar Khatua",
    orderdate: "07 Jan, 2023",
    total: "Rs 24000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Dispatch",
  },
  {
    id: 2,
    orderId: "#SK2540",
    billingName: "Ajit Kumar Khatua",
    orderdate: "07 Jan, 2023",
    total: "Rs 34000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Dispatch",
  },
  {
    id: 5,
    orderId: "#SK2543",
    billingName: "Alok Rout",
    orderdate: "05 Aug, 2023",
    total: "Rs 80000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Dispatch",
  },
  {
    id: 12,
    orderId: "#SK2546",
    billingName: "Abhihek Jaiswal",
    orderdate: "03 Jun, 2023",
    total: "Rs. 120000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fas fa-money-bill-alt",
    paymentMethod: "Dispatch",
  },
  {
    id: 14,
    orderId: "#SK2543",
    billingName: "Alok Rout",
    orderdate: "05 Aug, 2023",
    total: "Rs 150000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Dispatch",
  },
  {
    id: 23,
    orderId: "#SK2540",
    billingName: "Ajit Kumar Khatua",
    orderdate: "07 Jan, 2023",
    total: "Rs 56000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Dispatch",
  },
  {
    id: 25,
    orderId: "#SK2546",
    billingName: "Abhihek Jaiswal",
    orderdate: "03 Jun, 2023",
    total: "Rs 45600",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fas fa-money-bill-alt",
    paymentMethod: "Dispatch",
  },
  {
    id: 27,
    orderId: "#SK2543",
    billingName: "Alok Rout",
    orderdate: "05 Aug, 2023",
    total: "Rs 67000",
    badgeclass: "success",
    paymentStatus: "Paid",
    methodIcon: "fa-cc-mastercard",
    paymentMethod: "Dispatch",
  }
]

const cartData = {
  products: [
    {
      id: 1,
      img: "img1",
      name: "JEMSTAR",
      price: "450",
      data_attr: 1,
      total: 450,
    },
    {
      id: 2,
      img: "img2",
      name: "KRITAP 4G",
      price: "225",
      data_attr: 1,
      total: 225,
    },
    {
      id: 3,
      img: "img3",
      name: "KIPRO",
      price: "152",
      data_attr: 1,
      total: 152,
    },
    {
      id: 4,
      img: "img4",
      name: "KF-18",
      price: "290",
      data_attr: 1,
      total: 290,
    },
    {
      id: 5,
      img: "img5",
      name: "FLICK SUPER",
      price: "138",
      data_attr: 1,
      total: 138,
    },
    {
      id: 6,
      img: "img6",
      name: "KRILAYXL GOLD",
      price: "152",
      data_attr: 1,
      total: 152,
    },
  ],
  orderSummary: {
    grandTotal: "$ 1,857",
    discount: "$ 157",
    shippingCharge: "$ 25",
    estimatedTax: "$ 19.22",
    total: "$ 1744.22",
  },
};

const customerData = [
  {
    id: 1,
    username: "Ajit Khatua",
    phone: "8018269536",
    email: "ajit@gmail.com",
    address: "O-176, Jhinkiria,Cuttack,Odisha",
    companyName: "Kaveri Motor Private Limited",
    rating: "4.2",
    walletBalance: "$5,412",
    joiningDate: "07 Aug, 2019",
  },
  {
    id: 2,
    username: "Biswajit Pradhan",
    phone: "6371506095",
    email: "biswajit@gmail.com",
    companyName: "JK Private Limited",
    address: "N-186, Berhampur,Cuttack,Odisha",
    rating: "4.0",
    walletBalance: "$5,632",
    joiningDate: "06 Oct, 2019",
  },
  {
    id: 3,
    username: "Ajay Jamage",
    phone: "9933750695",
    email: "ajay@gmail.com",
    companyName: "Metro Decor",
    address: "3632, Lagpath Nagar, New Delhi,India",
    rating: "4.4",
    walletBalance: "$7,523",
    joiningDate: "06 Mar, 2020",
  },
  {
    id: 4,
    username: "Ketan Pradhan",
    phone: "6371091440",
    email: "ketan@gmail.com",
    companyName: "Nath Suppliers",
    address: "A-186,Sai Indu Tower, Mumbai , Maharashtra ",
    rating: "4.1",
    walletBalance: "$6,325",
    joiningDate: "05 July, 2020",
  },
  {
    id: 5,
    username: "Sashank Chawan",
    phone: "9658290924",
    email: "sashank@gmail.com",
    companyName: "Dhunseri Agrovet Limited",
    address: "B-159, Dibati, Cuttack, Odisha ",
    rating: "3.8",
    walletBalance: "$4,523",
    joiningDate: "04 Dec, 2020",
  },
  {
    id: 6,
    username: "SatyaPrakash Barik",
    phone: "7682054886",
    email: "satya@gmail.com",
    companyName: "Greeta",
    address: "L-159, Nellure , Andhra Pradesh, 700234",
    rating: "4.0",
    walletBalance: "$5,412",
    joiningDate: "03 Feb, 2021",
  },
  {
    id: 7,
    username: "Alok Pradhan",
    phone: "7008308838",
    email: "alok@gmail.com",
    companyName: "Rath Private Limited",
    address: "NuaBazar,Cuttack , Odisha , 759039",
    rating: "4.2",
    walletBalance: "$6,180",
    joiningDate: "02 April, 2021",
  },
  {
    id: 8,
    username: "Bharat Shukla",
    phone: "8093407183",
    email: "bharat@gmail.com",
    companyName: "National Motor-Industry",
    address: "N-108, Markat Nagar, Pune , Maharashtra",
    rating: "4.1",
    walletBalance: "$5,2870",
    joiningDate: "02 June, 2021",
  },
  {
    id: 9,
    username: "Mamata Rout",
    phone: "6074213490",
    email: "mamata@gmail.com",
    companyName: "Advanta Limited",
    address: "M-146, Bermunda, Bhubaneswar , Odisha",
    rating: "4.2",
    walletBalance: "$5,412",
    joiningDate: "07 Oct, 2021",
  },
  {
    id: 10,
    username: "Kapil Sharma",
    phone: "9080165386",
    email: "kapil@gmail.com",
    companyName: "Monsanto India",
    address: "P-123, Nayapali, Bhuabaneswar, Odisha ",
    rating: "4.0",
    walletBalance: "$5,632",
    joiningDate: "06 Jan, 2022",
  },
  {
    id: 11,
    username: "Brijesh Kar",
    phone: "8760235406",
    email: "brijesh@gmail.com",
    companyName: "Dhunseri Public Limited.",
    address: "B-185, Laxmi Nagar, Kendrapada , Odisha",
    rating: "4.4",
    walletBalance: "$7,523",
    joiningDate: "06 Aug, 2022",
  },
  {
    id: 12,
    username: "Swati Debata",
    phone: "9090407186",
    email: "swati@gmail.com",
    companyName: "Monsanto India",
    address: " M-180, Kharbela Nagar, Bhubaneswar, Odisha",
    rating: "4.1",
    walletBalance: "$6,325",
    joiningDate: "05 Nov, 2022",
  },
  {
    id: 13,
    username: "Arati Khatua",
    phone: "9175203760",
    email: "arati@gmail.com",
    companyName: "Raghuvansh Pvt Ltd",
    address: "S-140, Kamakhya Nagar, Dhenkanal, Odisha",
    rating: "3.8",
    walletBalance: "$4,523",
    joiningDate: "04 Mar, 2023",
  },
];

const categoryData = [
 {
  Id:1,
  CategoryName:"Compressors",
  CategoryDiscription:"Subros has a wide range of reciprocating compressors, compatible with eco friendly refrigerant. These compressors are available in different size and capacity to suit all requirements and engine power. Their unique design ensures that these compressors draw minimum power from engine and work efficiently and silentlyx",
  img:com3
 },
 {
  Id:2,
  CategoryName:"Condensers",
  CategoryDiscription:"Subros is the largest manufacturer of automotive condensers in India. These condensers are manufactured in technical collaboration with Denso Corporation Japan.The new range of Multi-Flow & Multi-Flow with Integrated Receiver Drier condensers are a new revolution in heat exchangers, which are super efficient, small in size and light in weight.",
  img:cond
 },
 {
  Id:3,
  CategoryName:"HVAC",
  CategoryDiscription:"It is abbreviation for heating, ventilation, and air conditioning systems, the technology of indoor or automotive environmental comfort",
  img:eva
 },
 {
  Id:4,
  CategoryName:"Tubes & Hoses",
  CategoryDiscription:"Tubes & Hoses made from special grade aluminium material with wrinkle free bending and special grade rubber material for carrying high pressure environment friendly refrigerant from Compressor to Condenser to Evaporator in order to keep the vehicle cabin cool during summer",
  img:tubes
 },
 {
  Id:5,
  CategoryName:"Bus AC",
  CategoryDiscription:"Subros provides complete range of Bus Air conditioners ranging from 7.5 KW to 36 KW capacity suitable for 4 mtr to 12 mtr buses. High cooling performance and air flow volume have been achieved by the introduction of highly efficient evaporator and condenser and lowering air flow resistance. Fuel saving has been achieved by increased refrigeration cycle efficiency with the introduction of new multi- flow condensers. It uses environment friendly R 134a refrigerant",
  img:slr8
},
 {
  Id:6,
  CategoryName:"Rail AC",
  CategoryDiscription:"Subros provides tailored system solutions for driver cabin AC of railway engines featuring compactness, flexibility and easiness to install, irrespective of whether they are diesel or electricity driven engine. We are also working on development of units for Coach AC",
  img:railAc
},
 {
  Id:7,
  CategoryName:"Residential AC",
  CategoryDiscription:"Subros has a complete range of Residential Air Conditioners i.e. Window AC & Split AC system & supplying these products as OEM/ODM to all the leading brands in the Market",
  img:split
},
 {
  Id:8,
  CategoryName:"Commercial AC",
  CategoryDiscription:"Subros caters to the demands of both Residential & Commercial Air-conditioner Market by providing a comprehensive product range of Light Commercial AC (1.5 TR ~ 4.0 TR ) & Ductable AC ranges ( 5.5 TR ~ 17.0 TR) to the customer",
  img:indoor1
},
//  {
//   Id:9,
//   CategoryName:"Transport Refrigeration System",
//   CategoryDiscription:"Subros provides a complete range of transport refrigeration solutions suitable for storage volume upto 50 cu.m for chilling & freezing applications. We design world class transport refrigeration systems keeping energy efficiency, cost effectiveness and safety features in mind making it suitable for preservation of fresh products",
//  }
];
const shops = [
  {
    id: 1,
    color: "primary",
    name: "Brendle's",
    product: 112,
    balance: "13,575",
    profileLink: "#",
  },
  {
    id: 2,
    color: "warning",
    name: "Tech Hifi",
    product: 104,
    balance: "11,145",
    profileLink: "#",
  },
  {
    id: 3,
    color: "danger",
    name: "Lafayette",
    product: 126,
    balance: "12,356",
    profileLink: "#",
  },
  {
    id: 4,
    color: "success",
    name: "Packer",
    product: 102,
    balance: "11,228",
    profileLink: "#",
  },
  {
    id: 5,
    color: "info",
    name: "Nedick's",
    product: 96,
    balance: "9,235",
    profileLink: "#",
  },
  {
    id: 6,
    color: "dark",
    name: "Hudson's",
    product: 120,
    balance: "14,794",
    profileLink: "#",
  },
  {
    id: 7,
    color: "dark",
    name: "Tech Hifi",
    product: 104,
    balance: "11,145",
    profileLink: "#",
  },
  {
    id: 8,
    color: "primary",
    name: "Brendle's",
    product: 112,
    balance: "13,575",
    profileLink: "#",
  },
  {
    id: 9,
    color: "success",
    name: "Lafayette",
    product: 120,
    balance: "12,356",
    profileLink: "#",
  },
];
const productComments = [
  {
    commentId: 1,
    user: {
      name: "Brian",
      profile: "avatar2",
    },
    comment:
      "If several languages coalesce, the grammar of the resulting language.",
    time: "5 hrs ago",
    hasLiked: false,
  },
  {
    commentId: 2,
    user: {
      name: "Denver",
      profile: "avatar4",
    },
    comment:
      "To an English person, it will seem like simplified English, as a skeptical Cambridge",
    time: "07 Oct, 2019",
    hasLiked: false,
    replies: [
      {
        commentId: 2,
        replyId: 1,
        user: {
          name: "Henry",
          profile: "avatar5",
        },
        comment:
          "Their separate existence is a myth. For science, music, sport, etc.",
        time: "08 Oct, 2019",
        hasLiked: false,
      },
    ],
  },
  {
    commentId: 3,
    user: {
      name: "Neal",
      profile: "avatar3",
    },
    comment: "Everyone realizes why a new common language would be desirable.",
    time: "05 Oct, 2019",
    hasLiked: false,
  },
];

const productListvar = [
  {
    id: 1,
    img: slr36,
    name: "SLR 36",
    price: "15000",
    data_attr: 1,
    description:"Introducing our cutting-edge Roof Unit, a compact powerhouse with a 36 KW cooling capacity. Measuring 3720 X 2000 X 243 mm, it delivers a refreshing air flow of 6600 m3/h. Powered by a reliable Bitzer/Valeo compressor (650 cc), it operates at an efficient 68A @ 24V. Elevate your climate control with this sleek, space-saving solution – where advanced cooling meets optimized design for unparalleled performance.",
    total: 15000,
  },
  {
    id: 2,
    img: slr8,
    name: "SLR 8",
    price: "14000",
    data_attr: 1,
    description:"Introducing our cutting-edge Roof Unit, a compact powerhouse with a 36 KW cooling capacity. Measuring 3720 X 2000 X 243 mm, it delivers a refreshing air flow of 6600 m3/h. Powered by a reliable Bitzer/Valeo compressor (650 cc), it operates at an efficient 68A @ 24V. Elevate your climate control with this sleek, space-saving solution – where advanced cooling meets optimized design for unparalleled performance.",
    total: 14000,
  },
  {
    id: 3,
    img: com3,
    name: "10SA13",
    price: "25000",
    data_attr: 1,
    description:"The 10SA13 is a compact FD Swash Plate compressor with 10 cylinders and a 125cc displacement, ideal for diverse applications requiring efficiency and reliability in compressed air or fluid handling.",
    total: 25000,
  },
  {
    id: 4,
    img: com,
    name: "10S11",
    price: "30020",
    data_attr: 1,
    description:"The 10S11 is an FD Swash Plate compressor with 10 cylinders and a displacement of 117cc. This compact and reliable compressor is designed for versatility, making it suitable for a range of applications that require efficient compressed air or fluid handling.",
    total: 30020,
  },
  {
    id: 5,
    img: cond,
    name: "Multiflow",
    price: "11780",
    data_attr: 1,
    description:"The new range of Multi-Flow condensers are a new revolution in heat exchangers, which are super efficient, small in size and light in weight.",
    total: 11780,
  },
  {
    id: 6,
    img: heat,
    name: "Heaters",
    price: "11310",
    data_attr: 1,
    description:"It helps to control growth of different kinds of weeds.",
    total: 11310,
  },
];

export {
  productsData,
  recentProducts,
  comments,
  discountData,
  orders,
  deliveredOrders,
  returnOrders,
  pendingOrders,
  shops,
  customerData,
  cartData,
  productComments,
  productListvar,
  categoryData,
  deportReportData,
  deportData,
  exclusiveData,
  productsOfferData,
  deportDataForSalesUser,
  newProductData,
  canceledOrders
};
